import React from 'react';
import { useSelector } from 'react-redux';

/* External */
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

/* Project */
import DeleteModal from 'commons/components/DeleteModal';
import ItemList from 'screens/Dispatches/components/ItemList';
import Filters from 'screens/Dispatches/components/Filters';
import DispatchForm from 'screens/Dispatches/components/DispatchForm';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';

import { useTranslation } from 'react-i18next';

function DispatchesComponent(props) {
  const { t } = useTranslation();
  const {
    classes,
    objects,
    toggleForm,
    closeForm,
    submitDelete,
    defaultFilters,
    defaultPagination,
    headerList,
    role,
  } = props;
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: role?.name,
  });
  const { canCreate } = accessPolicy.dispatches;

  const formIsOpen = useSelector((state) => state.dispatches.formIsOpen);
  const deleteIsOpen = useSelector((state) => state.dispatches.deleteIsOpen);
  const inputSearch = useSelector((state) => state.dispatches.inputSearch);

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Dispatches')}
          </Typography>
        </Grid>
        <Filters
          classes={classes}
          defaultFilters={defaultFilters}
          defaultPagination={defaultPagination}
        />
        <Grid container xs={12}>
          <ItemList
            classes={classes}
            objects={objects}
            headerList={headerList}
            inputSearch={inputSearch}
          />
        </Grid>
      </Grid>
      {formIsOpen && <DispatchForm toggleForm={toggleForm} objects={objects} />}
      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
        buttonId="delete-dispatch"
      />
      {canCreate && (
        <Fab color="primary" aria-label="add" className={classes.fab} onClick={toggleForm}>
          <AddIcon />
        </Fab>
      )}
    </Container>
  );
}

// const withSaga = connectSaga({ key: 'sagaDispatches', saga });

// const withConnect = connect(undefined, undefined);

// export default compose(withConnect)(withSaga(DispatchesComponent));

export default DispatchesComponent;
